import uris from '../utils/uris'
import axios from '../utils/axiosWrapper'

let userInfo = {}
// let userCards = ['REMOTE FILES', 'CONSISTENCIES', 'DATABASE']
/* let userCards = [
  {cardType: 'REMOTE FILES', cardName: 'Archivos FTP', enabled: true, reference: 'Archivos remotos'},
  {cardType: 'CONSISTENCIES', cardName: 'Consistencias', enabled: true, reference: 'Consistencias'},
  {cardType: 'DATABASE', cardName: 'Base de datos', enabled: true, reference: 'Base de datos'},
  {cardType: 'REPORTS GENERATOR', cardName: 'Generador de reportes', enabled: false, reference: 'Generador de reportes'},
  {cardType: 'SHIPPING CONTROL', cardName: 'Control de envío', enabled: false, reference: 'Control de envío'},
  {cardType: 'VALIDATOR', cardName: 'Validador', enabled: false, reference: 'Validador'}
] */
export default {
  getUserInfo () {
    try {
      userInfo = JSON.parse(localStorage.user || '{}')
    } catch (ex) {
      delete localStorage.token
      delete localStorage.user
    }
    return userInfo
  },
  updateUserInfo (options) {
    userInfo = options.data
    localStorage.user = JSON.stringify(userInfo)
    axios.post(uris.URL_UPDATE_USER_INFO, options.data)
      .then((response) => {
        // console.log('USER UPDATED', response)
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('ERROR UPDATING USER', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  updatePassword (options) {
    axios.post(uris.URL_UPDATE_USER_PASSWORD, {
      newPassword: options.newPassword
    })
      .then((response) => {
        // console.log('USER PASSWORD UPDATED', response)
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('ERROR UPDATING USER PASSWORD', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/storage/userStorage.js